import { memo } from 'react';
import { InlineStack, Text, Checkbox, BlockStack } from '@shopify/polaris';
import { TemplateFeatures } from './types/template';

type TemplateFiltersProps = {
  selectedFeatures: Set<TemplateFeatures>;
  toggleFeature: (feature: TemplateFeatures) => void;
  inline?: boolean;
};

const TemplateFilters = ({ selectedFeatures, toggleFeature, inline = false }: TemplateFiltersProps) => {
  const Stack = inline ? InlineStack : BlockStack;

  return (
    <>
      <Stack gap={inline ? '500' : '400'}>
        <Checkbox
          label="Includes influencer"
          checked={selectedFeatures.has(TemplateFeatures.Avatar)}
          onChange={() => toggleFeature(TemplateFeatures.Avatar)}
        />
        <Checkbox
          label="Bulk creation"
          checked={selectedFeatures.has(TemplateFeatures.BulkCreation)}
          onChange={() => toggleFeature(TemplateFeatures.BulkCreation)}
        />
        <Checkbox
          label="Product focus"
          checked={selectedFeatures.has(TemplateFeatures.ProductFocus)}
          onChange={() => toggleFeature(TemplateFeatures.ProductFocus)}
        />
      </Stack>
    </>
  );
};

export default memo(TemplateFilters);
